import React, { SetStateAction, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authApi from '../../api/auth';
import legalApi from '../../api/legal';
import { BACK_ARROW, CHECK_ICON } from '../../assets/icons';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { login } from '../../reducers/authSlice';
import { Button, Markdown } from '@wot/components';
import { ILegal } from '@wot/typings';

interface IloginStep {
  setStep: React.Dispatch<SetStateAction<number>>;
}

const LicenseTerms: React.FC<IloginStep> = ({ setStep }) => {
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.authSlice);
  const { userData } = useAppSelector((state) => state.userSlice);
  // const [checked, setChecked] = useState(false);
  const dispatch = useAppDispatch();

  const [terms, setTerms] = useState<ILegal[]>([]);

  useEffect(() => {
    legalApi
      .getDocuments('terms-conditions')
      .then((data) => {
        if (data) {
          setTerms(data);
        }
      })
      .catch((/* err */) => { });
  }, []);

  useEffect(() => {
    if (user?._id) {
      if (user.termsOfUse === 'accepted') {
        if (userData) {
          navigate('/dashboard');
        } else {
          setStep(2);
        }
      }
    }
  }, [user, setStep, userData, navigate]);

  if (!user?._id) {
    setStep(0);
    return null;
  }
  const accept = () => {
    if (!user?._id) {
      setStep(0);
      return;
    }
    // if (!checked) {
    //   return;
    // }
    authApi
      .acceptTermsOfUsage(user._id)
      .then((res) => {
        if (res.status === 'OK') {
          dispatch(login({ ...user, termsOfUse: 'accepted' }));
          setStep(2);
        }
      })
      .catch((err) => err);
  };

  return (
    <div className="w-full h-full flex flex-col justify-center items-center md:mt-14">
      <div className="flex lg:flex-row flex-col w-full justify-between lg:gap-0 gap-6">
        <img
          src={BACK_ARROW}
          alt="Go back"
          className="w-5 cursor-pointer"
          onClick={async () => {
            await authApi.logout();
            setStep(0);
          }}
        />
        <h5 className="text-black text-left md:text-center text-2xl md:text-xl font-semibold w-full">
          Please review and agree to the licence terms
        </h5>
      </div>
      <div className="my-4 text-xs md:text-sm overflow-auto h-[450px] md:h-96">
        <Markdown markdown={terms[0]?.mdText || ''} />
      </div>
      {/* <div className="w-full h-full mt-auto flex flex-row items-center gap-4 py-2 md:py-4">
        <div className={`w-6 h-6 relative text-sm rounded-md cursor-pointer shrink-0`}>
          <input
            checked={checked}
            name={''}
            type="checkbox"
            onChange={() => setChecked(!checked)}
            className={`absolute top-0 left-0 z-20 w-full h-full appearance-none cursor-pointer`}
          />
          <div
            className={`absolute top-0 left-0 w-full h-full rounded-md border transition-all flex items-center justify-center 
         ${checked ? 'border-primary bg-neutralBlue1' : 'border-neutralGray3 bg-white'} `}
          >
            {checked && <img src={CHECK_ICON} className="" alt="" />}
          </div>
        </div>

        <p className="font-semibold text-sm ">
          By checking this box you accept to our terms of service and privacy policy.
        </p>
      </div> */}
      <div className="w-full">
        <Button block text="Accept" onClick={() => accept()} size="lg" />
      </div>
    </div>
  );
};

export default LicenseTerms;
